import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';
import { GeneratorState } from '../../slices/generator';

export const selectSelectedLocals = (): any =>
    createSelector(
        (state: RootState) => state.generator,
        (state: GeneratorState) => state.selectedLocals,
    );
